export const APPROVED_STATUS = 'approved';
export const SUBMITTED_FOR_APPROVAL_STATUS = 'submitted_for_approval';
export const ONBOARDING_STARTED_AGENCY_STATUS = 'onboarding_started';
export const LEAD_AGENCY_STATUS = 'lead';

export const APPROVED_AGENCY_STATUSES = [
  APPROVED_STATUS,
  SUBMITTED_FOR_APPROVAL_STATUS,
];

export const complianceStatuses = Object.freeze({
  NON_VERIFIED: 'non_verified',
  PENDING_TO_REVIEW: 'pending_to_review',
  NEEDS_MORE_INFO: 'needs_more_info',
  VERIFIED_INTERNALLY: 'verified_internally',
  VERIFIED_EXTERNALLY: 'verified_externally',
});

export const UNKNOWN_AGENCY_NAME = 'Unknown agency name';

export const status = Object.freeze({
  APPROVED: APPROVED_STATUS,
  CLOSED_LOST: 'closed_lost',
});

export const ONBOARDING_QUESTIONS = {
  name: 'Agency Name',
  dba: 'DBA (optional)',
  email: 'Agency Email',
  phone: 'Agency Phone',
  agency_code: 'ABN',
};

export const FLORIDA_LICENSE = 'florida_license';

export const CUSTOM_AGENCY_ROUTES_MAP = Object.freeze({
  [FLORIDA_LICENSE]: [
    '/my-agency/compliance/florida-license',
    '/my-agency/edit/florida-license',
    '/onboarding/florida-license',
  ],
});

export const INTERMEDIARIES = [
  {
    label: '5Star Specialty Programs',
    value: '5Star Specialty Programs',
  },
  {
    label: 'Abacus Insurance',
    value: 'Abacus Insurance',
  },
  {
    label: 'AmRisc, L.P.',
    value: 'AmRisc, L.P.',
  },
  {
    label: 'Apogee Insurance Group',
    value: 'Apogee Insurance Group',
  },
  {
    label: 'Appalachian Underwriters',
    value: 'Appalachian Underwriters',
  },
  {
    label: 'Arc Excess & Surplus LLC',
    value: 'Arc Excess & Surplus LLC',
  },
  {
    label: 'Atlas',
    value: 'Atlas',
  },
  {
    label: 'Bass',
    value: 'Bass',
  },
  {
    label: 'Builders & Tradesman Insurance Services',
    value: 'Builders & Tradesman Insurance Services',
  },
  {
    label: 'Burns & Wilcox',
    value: 'Burns & Wilcox',
  },
  {
    label: 'CCI Surety',
    value: 'CCI Surety',
  },
  {
    label: 'CIS Insurance Services, LLC',
    value: 'CIS Insurance Services, LLC',
  },
  {
    label: 'CRC Group',
    value: 'CRC Group',
  },
  {
    label: 'Dovetail',
    value: 'Dovetail',
  },
  {
    label: 'Gresham & Associates',
    value: 'Gresham & Associates',
  },
  {
    label: 'K&K Insurance Group',
    value: 'K&K Insurance Group',
  },
  {
    label: 'Lancer Insurance Company',
    value: 'Lancer Insurance Company',
  },
  {
    label: 'NCCI',
    value: 'NCCI',
  },
  {
    label: 'Program Brokerage',
    value: 'Program Brokerage',
  },
  {
    label: 'REX (Risk Exchange Insurance Services, Inc.)',
    value: 'REX (Risk Exchange Insurance Services, Inc.)',
  },
  {
    label: 'RPS',
    value: 'RPS',
  },
  {
    label: 'RT Specialty',
    value: 'RT Specialty',
  },
  {
    label: 'Russell Bond',
    value: 'Russell Bond',
  },
  {
    label: 'Synergy Professional Associates',
    value: 'Synergy Professional Associates',
  },
  {
    label: 'Tapco Insurance Services',
    value: 'Tapco Insurance Services',
  },
  {
    label: 'Target Professional Programs',
    value: 'Target Professional Programs',
  },
  {
    label: 'The Shinnerer Group',
    value: 'The Shinnerer Group',
  },
  {
    label: 'The Sullivan Group',
    value: 'The Sullivan Group',
  },
  {
    label: 'UCPM Environmental Insurance',
    value: 'UCPM Environmental Insurance',
  },
];

export const MANAGEMENT_SYSTEMS = [
  {
    label: 'Xanatek – Xanatek IMS',
    value: 'Xanatek – Xanatek IMS',
  },
  {
    label: 'Applied Systems – Applied Epic',
    value: 'Applied Systems – Applied Epic',
  },
  {
    label: 'Applied Systems – Applied TAM',
    value: 'Applied Systems – Applied TAM',
  },
  {
    label: 'Applied Systems – TechCanary',
    value: 'Applied Systems – TechCanary',
  },
  {
    label: 'Evolution Agency Mgmt. – Evolution eVo',
    value: 'Evolution Agency Mgmt. – Evolution eVo',
  },
  {
    label: 'Hawksoft – Hawksoft CMS',
    value: 'Hawksoft – Hawksoft CMS',
  },
  {
    label: 'EZLynx – EZLynx Management System',
    value: 'EZLynx – EZLynx Management System',
  },
  {
    label: 'XDimensional Technology – Nexsure',
    value: 'XDimensional Technology – Nexsure',
  },
  {
    label: 'SIS – SIS Partner XE',
    value: 'SIS – SIS Partner XE',
  },
  {
    label: 'Insurance Tech. Corp. – ITC InsurancePro',
    value: 'Insurance Tech. Corp. – ITC InsurancePro',
  },
  {
    label: 'NASA – NASA Eclipse',
    value: 'NASA – NASA Eclipse',
  },
  {
    label: 'Jenesis – Jenesis',
    value: 'Jenesis – Jenesis',
  },
  {
    label: 'NowCerts AMS – NowCerts',
    value: 'NowCerts AMS – NowCerts',
  },
  {
    label: 'Vertafore – QQ Catalyst',
    value: 'Vertafore – QQ Catalyst',
  },
  {
    label: 'Vertafore – Vertafore Agency Platform (including AMS 360)',
    value: 'Vertafore – Vertafore Agency Platform (including AMS 360)',
  },
  {
    label: 'Vertafore – Vertafore Sagitta',
    value: 'Vertafore – Vertafore Sagitta',
  },
];
